import styled from '../../styles/styled';
import { Box } from './box';
export const Flex = styled(Box)({
    display: 'flex',
});
export const Row = styled(Flex)({
    flexDirection: 'row',
});
export const Column = styled(Flex)({
    flexDirection: 'column',
});
//# sourceMappingURL=flex.js.map